import Artists, { ArtistsAsString } from './artists'

export { ArtistsAsString }

export default Artists
